import get from 'lodash.get';
const getActiveListingForRenter = (renter) => {
  return get(renter, 'listings[0]', {});
};

export default getActiveListingForRenter;
